'use client';

import { tw } from '@tw';
import { QuizMuteButton } from './QuizMuteButton';

/**
 * The one row over a question: "3 of 10" beside a rail of equal segments lit
 * up to where the player is, with the speaker at its end. No title: the
 * question is the head. Shared by the storefront card and the builder's
 * rehearsal, so the two players cannot drift.
 */
export function QuizProgressRow({ at, of, inert }: { at: number; of: number; inert?: boolean }) {
  return (
    <div className={tw('flex items-center gap-3', inert && 'pointer-events-none')}>
      <span className="sf-num text-badge font-bold text-white/90">
        {Math.min(at, of)} of {of}
      </span>
      <div className="flex flex-1 gap-1">
        {Array.from({ length: of }, (_, index) => (
          <span
            key={index}
            className={tw('h-[3px] flex-1 rounded-full', index < at ? 'bg-white' : 'bg-white/30')}
          />
        ))}
      </div>
      <QuizMuteButton />
    </div>
  );
}
